import { getAsync } from '../../helpers/Api/Api';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Client, Nullable } from '@xplan-pension-switching/common';

const CACHE_KEY_ENTITY = 'entity-details';

export const getEntityDetails = async (
    entityId: number
): Promise<{
    client: Client;
    partner: Nullable<Client>;
    displayName: string;
    displayDetails: string;
}> => {
    return await getAsync<{
        client: Client;
        partner: Client;
        displayName: string;
        displayDetails: string;
    }>(`api/entity-details/${entityId}`);
};

export const useEntityDetailsQuery = (entityId?: number) =>
    useSuspenseQuery({
        queryKey: [CACHE_KEY_ENTITY, entityId],
        staleTime: Number.POSITIVE_INFINITY,
        queryFn: () => getEntityDetails(entityId!),
    });
